module.exports = __webpack_public_path__ + "static/media/blind-destiny.9c155229.png";